// 站点公示信息（备案主体、联系方式），协议 / 隐私政策 / 投诉举报页和页脚共用。改这里即可全站生效。
export const site = {
  name: "个人CS2Coach网",
  domain: "cs2coach.cn",
  operator: "孙凡",
  email: "sun_fan99@qq.com",
  phone: "18051011588",
  /** ICP 备案号，如「苏ICP备XXXXXXXX号-1」；留空则页脚不显示。 */
  icp: "苏ICP备2024065508号-3",
  /** 公安联网备案号，如「苏公网安备 32010XXXXXXXXX号」；留空则页脚不显示。 */
  police: "",
  /** 协议与隐私政策的生效日期。 */
  effective: "2026 年 10 月 27 日",
  /** 协议版本，与后端 compliance.PolicyVersion 一致；改协议时两边一起改，老用户会被要求重新确认。 */
  policyVersion: "2026-10-27",
};
